
function Footer() {
    return (
        <>
            <footer className="bg-gradient-to-r from-[#2e0000] via-[#3c0606] to-[#3a0000] text-white">
                <div className="max-w-7xl mx-auto py-5 px-4 overflow-hidden sm:px-6 lg:px-8">
                    <div className="mt-4 flex justify-center space-x-6">
                        <img src="./logo192.webp" alt="Sai Logo" className="w-[2.2cm] rounded-[50px]" />
                    </div>
                    <p className="text-center text-base">© 2026 Copyright Sai | All rights reserved</p>
                </div>
            </footer>
        </>
    );
}

export default Footer;